import { render } from "./AsideComponent.vue?vue&type=template&id=66564a63&scoped=true"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"

import "./AsideComponent.vue?vue&type=style&index=0&id=66564a63&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66564a63"]])

export default __exports__